import { useState } from "react";

export const getBackendUrl = (): string => {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    console.log('[getBackendUrl] hostname:', hostname);

    if (hostname.includes(".e2b.app")) {
      const match = hostname.match(/(\d+)-(.+)\.e2b\.app/);
      console.log('[getBackendUrl] match:', match);

      if (match) {
        const [, , instanceId] = match;
        const backendUrl = `https://5000-${instanceId}.e2b.app`;
        console.log('[getBackendUrl] returning:', backendUrl);
        return backendUrl;
      }
    }
  }

  const fallbackUrl = "http://localhost:5000";
  console.log('[getBackendUrl] returning fallback:', fallbackUrl);
  return fallbackUrl;
};

export const useGetBackendUrl = (): any => {
  const [backendUrl] = useState<string>(getBackendUrl);
  return backendUrl;
};
